module.exports = __webpack_public_path__ + "static/media/Noirden-SemiBold.7d67ed46.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-SemiBold.eot
// module id = 2954
// module chunks = 70